/**
 * Selects the app rating information.
 * @param {Object} state The current state.
 * @returns {Object} The app rating information.
 */export var getAppRatingState=function getAppRatingState(state){return state.appRating;};